import { transformWebhookToPredictionCharts } from '@/lib/predictions/webhookTransformer';
import { updateChartCache } from '@/lib/predictions/chartCache';
import { savePredictionsToDatabase } from './database';
import { PredictionData } from './types';

const WEBHOOK_URL = 'https://hook.eu1.make.com/erhr23gmu4unwyjlz2pscr2a8lvr9ms7';

export const triggerPredictionsWebhook = async (): Promise<void> => {
  console.log('[Webhook] 🚀 Triggering predictions webhook...');
  
  try {
    const response = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'generate_predictions',
        timestamp: new Date().toISOString()
      })
    });

    if (!response.ok) {
      console.error('[Webhook] ❌ HTTP error:', response.status, response.statusText);
      return;
    }

    const webhookData = await response.json();
    console.log('[Webhook] 📦 Raw webhook response received:', JSON.stringify(webhookData, null, 2));

    // Transform webhook data to chart format
    const chartData = transformWebhookToPredictionCharts(webhookData);
    console.log('[Webhook] 🔄 Chart data transformed:', {
      hasGold: !!chartData.gold,
      hasSilver: !!chartData.silver
    });

    // Update chart cache
    updateChartCache(chartData);
    console.log('[Webhook] 💾 Chart cache updated');

    // Prepare data for database saving (both textual and chart data)
    const predictionsToSave: PredictionData[] = [];
    
    if (chartData.gold) {
      predictionsToSave.push({
        metal: 'ORO',
        prediction: webhookData.previsione_oro?.markdown || 'Previsione oro generata',
        price_trend: chartData.gold.targetPercentage > 0 ? 'UP' : chartData.gold.targetPercentage < 0 ? 'DOWN' : 'STABLE',
        confidence_score: chartData.gold.confidence,
        prediction_date: new Date().toISOString(),
        // Chart data
        time_series: chartData.gold.timeSeries,
        scenarios: chartData.gold.scenarios,
        current_price: chartData.gold.currentPrice,
        target_price: chartData.gold.targetPrice,
        target_percentage: chartData.gold.targetPercentage,
        timeframe: chartData.gold.timeframe
      });
    }

    if (chartData.silver) {
      predictionsToSave.push({
        metal: 'ARGENTO',
        prediction: webhookData.previsione_argento?.markdown || 'Previsione argento generata',
        price_trend: chartData.silver.targetPercentage > 0 ? 'UP' : chartData.silver.targetPercentage < 0 ? 'DOWN' : 'STABLE',
        confidence_score: chartData.silver.confidence,
        prediction_date: new Date().toISOString(),
        // Chart data
        time_series: chartData.silver.timeSeries,
        scenarios: chartData.silver.scenarios,
        current_price: chartData.silver.currentPrice,
        target_price: chartData.silver.targetPrice,
        target_percentage: chartData.silver.targetPercentage,
        timeframe: chartData.silver.timeframe
      });
    }

    // Save to database with both textual and chart data
    if (predictionsToSave.length > 0) {
      const saved = await savePredictionsToDatabase(predictionsToSave);
      console.log('[Webhook] 🗄️ Database save result:', saved ? 'SUCCESS' : 'FAILED');
    }

    console.log('[Webhook] ✅ Webhook processing completed successfully');
  } catch (error) {
    console.error('[Webhook] ❌ Error processing webhook:', error);
  }
};
